import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]

import BaseFilterComponent from './BaseFilterComponent.vue'

interface Props {
  label: string
  modelValue: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DateFilterComponent',
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseFilterComponent, { label: _ctx.label }, {
    default: _withCtx(() => [
      _createElementVNode("input", {
        value: _ctx.modelValue,
        type: "date",
        class: "form-control",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)))
      }, null, 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})